export const WHATSAPP_CONSTANTS = {
  STORAGE_KEY: 'whatsapp_business_data',
  CONFIG_ID: process.env.FB_CONFIG_ID || '',
  API_VERSION: 'v21.0',
  GRAPH_API_BASE: 'https://graph.facebook.com',
  TIMEOUT_DURATION: 5 * 60 * 1000, // 5 minutes
  TRUSTED_ORIGINS: [
    'https://www.facebook.com',
    'https://web.facebook.com'
  ]
} as const;

export const WORKFLOW_STEPS = {
  INITIAL: 0,
  EXCHANGE_TOKEN: 1,
  SUBSCRIBE_WEBHOOKS: 2,
  GET_PHONE_NUMBERS: 3,
  SEND_MESSAGE: 4,
  COMPLETED: 5
} as const;

export const FLOW_STATES = {
  INITIAL: 'initial',
  INITIALIZING: 'initializing',
  LAUNCHING_FACEBOOK_LOGIN: 'launching_facebook_login',
  FACEBOOK_LOGIN_LAUNCHED: 'facebook_login_launched',
  AUTHENTICATION_COMPLETE: 'authentication_complete',
  WAITING_FOR_WHATSAPP_SETUP: 'waiting_for_whatsapp_setup',
  COMPLETED: 'completed',
  BUSINESS_ONBOARDING_COMPLETED: 'business_onboarding_completed',
  POPUP_CLOSED: 'popup_closed',
  TIMEOUT: 'timeout',
  CANCELLED_BY_USER: 'cancelled_by_user',
  ERROR: 'error',
  AUTHENTICATION_FAILED: 'authentication_failed',
  SDK_UNAVAILABLE: 'sdk_unavailable',
  LAUNCH_FAILED: 'launch_failed'
} as const;

export const STATUS_MESSAGES = {
  [FLOW_STATES.INITIAL]: 'Listo para conectar con WhatsApp Business',
  [FLOW_STATES.INITIALIZING]: 'Inicializando conexión...',
  [FLOW_STATES.LAUNCHING_FACEBOOK_LOGIN]: 'Preparando autenticación con Facebook...',
  [FLOW_STATES.FACEBOOK_LOGIN_LAUNCHED]: 'Ventana de Facebook abierta. Completa la autenticación.',
  [FLOW_STATES.AUTHENTICATION_COMPLETE]: 'Autenticación completada. Configurando WhatsApp...',
  [FLOW_STATES.WAITING_FOR_WHATSAPP_SETUP]: 'Configurando WhatsApp Business. Sigue las instrucciones en la ventana.',
  [FLOW_STATES.COMPLETED]: 'Conexión establecida exitosamente',
  [FLOW_STATES.BUSINESS_ONBOARDING_COMPLETED]: 'WhatsApp Business configurado exitosamente. Listo para usar la API.',
  [FLOW_STATES.POPUP_CLOSED]: 'La ventana de Facebook fue cerrada. Puedes intentar nuevamente.',
  [FLOW_STATES.TIMEOUT]: 'Tiempo de espera agotado. La ventana pudo haber sido cerrada.',
  [FLOW_STATES.CANCELLED_BY_USER]: 'Proceso cancelado por el usuario',
  [FLOW_STATES.ERROR]: 'Error durante el proceso de conexión',
  [FLOW_STATES.AUTHENTICATION_FAILED]: 'Falló la autenticación con Facebook',
  [FLOW_STATES.SDK_UNAVAILABLE]: 'SDK de Facebook no disponible',
  [FLOW_STATES.LAUNCH_FAILED]: 'Error al iniciar el proceso'
} as const;

export const TEMPLATE_CATEGORIES = {
  UTILITY: 'UTILITY',
  MARKETING: 'MARKETING',
  AUTHENTICATION: 'AUTHENTICATION'
} as const;

export const MESSAGE_STATUSES = {
  ACCEPTED: 'accepted',
  DELIVERED: 'delivered',
  READ: 'read',
  FAILED: 'failed'
} as const;

export const LOG_LEVELS = {
  INFO: 'info',
  WARN: 'warn', 
  ERROR: 'error'
} as const;